const Cookies = require('js-cookie')
const configment = require('@adc/configment')
const instrument = require('@adc/instrument')
const graph = require('@adc/sdk')
const { utils: blueprintUtils } = require('@adc/blueprint')
const eventNames = require('./eventNames')
const standardTracking = require('./standardTracking')
const helpers = require('./helpers')

function track(event, props = {}) {
  typeof window !== 'undefined' &&
    window.dataLayer &&
    window.dataLayer.push({
      event,
      ...props,
    })
}

function trackDataLayerLoaded(user = {}, additionalData = {}) {
  track(eventNames.dataLayerLoaded, {
    cookieId: Cookies.get('BRID'),
    userLoggedIn: user.logged_in,
    ...(user?.logged_in ? standardTracking.user(user) : {}),
    ...additionalData,
  })
}

function trackPropertySave(listing, action, additionalData = {}) {
  track(eventNames.propertySave, {
    action,
    status: 'success',
    ...additionalData,
    ...standardTracking.listing(listing),
  })
}

const defaultSource = () => `adc:service:${configment.get('APP_NAME')}`

const trackInstrumentPageLoad = (
  user = {},
  productLine,
  source = defaultSource()
) => {
  trackUserDomainEvent({
    domainEventTypeName: graph.enums.DomainEventTypeName.PageViewed,
    user,
    source,
    data: {
      product_line: productLine,
    },
  })
}

// remove this, call it from apps and just pass in listing.urn
const trackUserDomainEvent = ({
  domainEventTypeName,
  user,
  data = {},
  source = defaultSource(),
  urlString = window.location.href,
}) => {
  if (!('marketing' in data)) {
    const marketingData =
      blueprintUtils.extractMarketingSupportPrefixes(urlString) || {}
    if (Object.keys(marketingData).length > 0) {
      data.marketing = marketingData
    }
  }

  instrument.default.domainEvent({
    type: domainEventTypeName,
    subject: helpers.getUrn(user),
    source,
    data,
  })
}

module.exports = {
  defaultSource,
  eventNames,
  track,
  trackDataLayerLoaded,
  trackPropertySave,
  trackInstrumentPageLoad,
  trackUserDomainEvent,
}
